<template>
  <!--测试用例-->
  <div v-if="problem.testcases" class="box">
    <label class="is-text-xs"><b>代码评阅</b></label>
    <div class="is-text-small">
      <div v-for="(testcase) in problem.staticTestcases" class="testcase-block">
        <div class="card-content condense">
          <p class="help is-primary">提交代码需要通过以下检查才能够评分</p>
          <p v-if="testcase.max_line_length" class="help">代码最大列数:
            {{ testcase.max_line_length }}</p>
          <p v-if="testcase.max_module_lines" class="help">代码最大行数:
            {{ testcase.max_module_lines }}</p>
          <p v-if="testcase.exclude_keywords" class="help">
            代码不能包含的关键词:
            {{ testcase.exclude_keywords }}</p>
          <p v-if="testcase.include_keywords" class="help">
            代码必须包含的关键词（ ; 和 | 为分隔符号）:
            {{ includeWords(testcase.include_keywords) }}</p>
          <div v-if="testcase.status >= 200" class="field-ok">
            <div class="is-flex is-vcenter">
              <div class="sa-icon sa-success animate">
                <span class="sa-line sa-tip animateSuccessTip"></span>
                <span class="sa-line sa-long animateSuccessLong"></span>
                <div class="sa-placeholder"></div>
                <div class="sa-fix"></div>
              </div>
              <span class="is-text-success">测试通过</span>
            </div>
          </div>
          <p v-if="testcase.status === 100" class="help is-text-danger">
            未通过： {{ testcase.result }}
          </p>
        </div>
      </div>
      <div v-for="(testcase, index) in problem.dynamicTestcases"
           :class="{'is-failed': [100, 101, 102, 103, -1].indexOf(testcase.status) >= 0}"
           @click="showTestcase(testcase)"
           class="testcase-block">
        <!--序号-->
        <div v-if="testcase.status >= 200" class="field-ok">
          <div class="is-flex is-vcenter">
            <div class="sa-icon sa-success animate">
              <span class="sa-line sa-tip animateSuccessTip"></span>
              <span class="sa-line sa-long animateSuccessLong"></span>
              <div class="sa-placeholder"></div>
              <div class="sa-fix"></div>
            </div>
            <span class="is-text-success">结果正确</span>
          </div>
        </div>
        <div class="field-index">
          <span
              :class="[testcase.status ? (testcase.status >= 200 ? 'is-success' : 'is-danger') : 'is-primary']"
              class="tag is-square">{{ index + 1 }}</span>
        </div>

        <!--期望的输入-->
        <div class="field-input">
          <a v-if="testcase.show" class="field-item">
            {{ testcase.input ? ('输入：' + testcase.input) : '无输入' }}</a>
          <span v-else class="field-item">输入隐藏 <v-color-icon name="lock"></v-color-icon></span>
        </div>

        <!--期望的输出-->
        <div class="field-output">
          <a v-if="testcase.show && !testcase.hide_output" class="field-item">
            <span v-if="testcase.output_file">
              请将结果保存到文件：{{ testcase.output_file.name }}
            </span>
            <span v-else>期望输出：{{ testcase.output }}</span>
          </a>
          <span v-else class="field-item">输出隐藏 <v-color-icon name="lock"></v-color-icon></span>
        </div>

        <!--运行结果-->
        <div class="field-result">
          <div v-if="testcase.status >= 200" class="testcase-result is-success">
            <span class="is-text-success">结果正确 [{{ testcase.exec_time }} ms]</span>
          </div>
          <div v-else-if="testcase.status === 100"
               class="testcase-result single-line is-failed">
            <p> 结果错误 [{{ testcase.exec_time }} ms] <a
                v-if="testcase.result"
                class="field-item">你的输出：
              <figure v-if="testcase.result.startsWith('data:image/png;base64,')"
                      class="image">
                <img :src="testcase.result">
              </figure>
              <span v-else>{{ testcase.result }}</span>
            </a></p>
          </div>
          <div v-else-if="testcase.status === 101"
               class="testcase-result single-line is-failed">
            <p> 运行时错误 [{{ testcase.exec_time }} ms] <a
                v-if="testcase.result"
                class="field-item">你的输出: {{ testcase.result }}</a></p>
          </div>
          <div v-else-if="testcase.status === 102" class="testcase-result is-failed">
            <p> 程序运行超时 [{{ testcase.exec_time }} ms]</p>
          </div>
          <div v-else-if="testcase.status === 103" class="testcase-result is-failed">
            超出内存限制
          </div>
          <div v-else-if="testcase.status === 104" class="testcase-result is-failed">
            输出超过 20000 字符限制
          </div>
          <div v-else-if="testcase.running" v-html="getOjStatus(testcase)"
               class="testcase-result"></div>
          <div v-else-if="testcase.status === -1" class="testcase-result is-warning">{{
              testcase.result
            }}
          </div>
        </div>
      </div>
      <div v-for="(testcase) in problem.styleTestcases"
           :class="{'is-failed': [100, 101, 102, 103, 104, -1].indexOf(testcase.status) >= 0}"
           class="testcase-block">
        <div class="card-content condense">
          <p class="help is-primary">
            代码风格检查 <span
              class="tag is-white">{{ parseInt((testcase.weight || 0) / allWeight * 100) }}%</span>
          </p>
          <p>----------------------</p>
          <!--运行结果-->
          <pre v-if="testcase.result"
               class="output">{{ testcase.result || '未提交评阅' }}</pre>
          <div v-if="testcase.static_score === 1" class="field-ok">
            <div class="is-flex is-vcenter">
              <div class="sa-icon sa-success animate">
                <span class="sa-line sa-tip animateSuccessTip"></span>
                <span class="sa-line sa-long animateSuccessLong"></span>
                <div class="sa-placeholder"></div>
                <div class="sa-fix"></div>
              </div>
              <span class="is-text-success">代码规范</span>
            </div>
          </div>
          <pre v-if="testcase.static_score"
               class="output">代码风格得分 {{ testcase.static_score * 10 }} / 10</pre>
        </div>
      </div>

    </div>

    <testcase-modal v-if="selectedTestcase"
                    :ctrl="modalShowTestcase"
                    :testcase="selectedTestcase"></testcase-modal>

  </div>

</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'
import OnlineJudgePython from '@/plugin/web_ide/OjPython'
import './check.css'
import TestcaseModal from '@/components/classroom/messages/partials/TestcaseModal'

export default {
  components: { TestcaseModal },
  props: ['problem'],
  data () {
    return {
      queueStatus: 0,
      selectedTestcase: null,
      modalShowTestcase: { active: false, isLarge: true, noHeader: true, noPadding: true, noFooter: true }
    }
  },
  computed: {
    'allWeight' () {
      if (this.problem && this.problem.testcases) {
        return this.problem.testcases.reduce((sum, testcase) => {
          return sum + parseInt(testcase.weight || 0)
        }, 0) || 1
      }
      return 1
    }
  },
  methods: {
    showTestcase (testcase) {
      this.modalShowTestcase.active = true
      this.selectedTestcase = testcase
    },
    includeWords (rawString) {
      const mustSplit = rawString.split(',')
      const optionalSplit = []
      // 放必须词
      const mustWords = []
      for (const word of mustSplit) {
        if (word.indexOf('|') < 0) {
          mustWords.push(word)
        } else {
          optionalSplit.push(word)
        }
      }
      const mustResult = mustWords.reduce((res, word) => {
        return res + word + ' ; '
      }, '')
      const optionalResult = optionalSplit.reduce((res, word) => {
        return res + word + ' 至少选一'
      }, '')
      return mustResult + optionalResult
    },
    resetCodeTemplate () {
      this.codes = this.problem.template || ''
      this.ui.modalResetCode.active = false
    },
    async runAllTestcase (code, onResult) {
      this.onResult = onResult
      this.onResultCount = this.problem.testcases.length
      await this.$api.put(`/student/courses/${IClassroom.course._id}/groups/${IClassroom.group._id}/problems/${this.problem._id}/code`, { code }, {}, 'single')
      this.python = new OnlineJudgePython(this, this.shell)
      await this.python.runProblemTestcases(this, `/student/courses/${IClassroom.course._id}/groups/${IClassroom.group._id}/problems/${this.problem._id}`, this.problem, onResult)
    },
    getOjStatus (testcase) {
      if (testcase.running) {
        if (this.queueStatus) {
          return '请稍候, 有 ' + this.queueStatus + ' 个习题正在评阅'
        }
        return '服务器正在努力评阅 ' + '<i class="fa fa-spinner fa-spin" "></i> Good Luck ~'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.box {
  padding 1rem 0
}

.card-content {
  padding .5rem
}

.testcase-block {
  position: relative;
  min-height: 80px;
  cursor: pointer;
  margin-bottom: .5rem;
  border-radius 10px
  border 1px solid #dddddd
  overflow hidden

  &:hover {
    background white
  }
}

.testcase-block.is-failed {
  color: #E25D4A;
}

.tag {
  line-height: 1.5;
  padding-left: .75em;
  padding-right: .75em;
  white-space: nowrap;

  &.is-danger {
    background $danger
    color white
  }

  &.is-success {
    background $success
    color white
  }
}

.testcase-block .tag {
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline;
  height: auto;
}

.field-index,
.field-input,
.field-output,
.field-result {
  display: inline-flex;
  min-height: 3rem;
  font-size: .8rem;
  padding: 0;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.field-index {
  font-weight: bold;
  margin-right: 10px;
}

.field-ok {
  position: absolute;
  opacity: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: inline-flex;
  justify-content: center;
  background: white;
  transition: .3s opacity;
}

.field-item {
  display: inline;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #363636;
}

.field-item:hover {
  color: #0dd1b2;
}

.testcase-block:hover .field-ok {
  opacity: 0;
  user-select: none;
  pointer-events: none;
}

.field-input, .field-output {
  width: 35%;
  max-width: 200px;
}

.field-result {
  border-top: 1px dashed #dddddd;
  width: 100%;
  padding: 0 10px;
}

.testcase-result.is-success {
  color: #23d160;
}

.testcase-result.is-failed {
  color: #E25D4A;
}

.output {
  background: none;
  padding: 0;
  max-height: 200px;
  overflow: auto;
}
</style>
